export const SET_WHATSAPP_APP = "SET_WHATSAPP_APP";
export const SET_WHATSAPP_APPS = "SET_WHATSAPP_APPS";
export const ADD_WHATSAPP_APP = "ADD_WHATSAPP_APP";
export const UPDATE_WHATSAPP_APP = "UPDATE_WHATSAPP_APP";
export const DELETE_WHATSAPP_APP = "DELETE_WHATSAPP_APP";
export const UPDATE_WHATSAPP_PHONE_NUMBER = "UPDATE_WHATSAPP_PHONE_NUMBER";
export const SET_WHATSAPP_PHONE_NUMBERS = "SET_WHATSAPP_PHONE_NUMBERS";
export const ADD_WHATSAPP_PHONE_NUMBER = "ADD_WHATSAPP_PHONE_NUMBER";
export const DELETE_WHATSAPP_PHONE_NUMBER = "DELETE_WHATSAPP_PHONE_NUMBER";
export const SET_WHATSAPP_MESSAGE_TEMPLATE = "SET_WHATSAPP_MESSAGE_TEMPLATE";
export const SET_WHATSAPP_MESSAGE_TEMPLATES = "SET_WHATSAPP_MESSAGE_TEMPLATES";
export const ADD_WHATSAPP_MESSAGE_TEMPLATE = "ADD_WHATSAPP_MESSAGE_TEMPLATE";
export const UPDATE_WHATSAPP_MESSAGE_TEMPLATE = "UPDATE_WHATSAPP_MESSAGE_TEMPLATE";
export const DELETE_WHATSAPP_MESSAGE_TEMPLATE = "DELETE_WHATSAPP_MESSAGE_TEMPLATE";
export const SET_WHATSAPP_QUICK_REPLY = "SET_WHATSAPP_QUICK_REPLY";
export const SET_WHATSAPP_QUICK_REPLIES = "SET_WHATSAPP_QUICK_REPLIES";
export const ADD_WHATSAPP_QUICK_REPLY = "ADD_WHATSAPP_QUICK_REPLY";
export const UPDATE_WHATSAPP_QUICK_REPLY = "UPDATE_WHATSAPP_QUICK_REPLY";
export const DELETE_WHATSAPP_QUICK_REPLY = "DELETE_WHATSAPP_QUICK_REPLY";
export const SET_WHATSAPP_ASSISTANT = "SET_WHATSAPP_ASSISTANT";
export const SET_WHATSAPP_ASSISTANT_NEW = "SET_WHATSAPP_ASSISTANT_NEW";
export const ADD_WHATSAPP_STEP_OPTION = "ADD_WHATSAPP_STEP_OPTION";
export const REMOVE_WHATSAPP_STEP_OPTION = "REMOVE_WHATSAPP_STEP_OPTION";
export const SET_WHATSAPP_ASSISTANT_CURRENT_STEP = "SET_WHATSAPP_ASSISTANT_CURRENT_STEP";
export const RESET_WHATSAPP_ASSISTANT = "RESET_WHATSAPP_ASSISTANT";
export const ADD_WHATSAPP_REPLY_USER = "ADD_WHATSAPP_REPLY_USER";
export const SET_WHATSAPP_ASSISTANT_TEMPLATE_STEP = "SET_WHATSAPP_ASSISTANT_TEMPLATE_STEP";
export const ADD_WHATSAPP_EXTRACT_DATA_RESPONSE = "ADD_WHATSAPP_EXTRACT_DATA_RESPONSE";
export const SET_TEAM_SCHEMA = "SET_TEAM_SCHEMA";
export const SET_SELECTED_PRODUCTS = "SET_SELECTED_PRODUCTS";
export const ADD_WHATSAPP_SELECTED_PRODUCT_STEP = "ADD_WHATSAPP_SELECTED_PRODUCT_STEP";
